import React from "react";

function LandIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8126 23.375C11.7293 22.3333 12.5913 20.6146 14.1876 18.8958C15.6828 17.286 16.3769 16.3333 17.4168 15.1042C18.7499 13.5281 20.5356 11.6567 21.8143 10.2188H20.1018C19.0821 11.024 16.1823 13.3222 15.5156 13.9375C14.7031 14.6875 9.96807 18.3813 8.68751 19.4375C5.9242 21.7164 0.502762 25.6851 0.499512 25.6875V31.5047H4.75014C4.75014 31.5047 6.13289 29.6105 7.00014 28.5625C8.40126 26.8694 9.43689 24.9383 10.8126 23.375Z"
        fill="#DB1920"
      />
      <path
        d="M0.499512 17.6041V22.6875C0.502762 22.6855 5.93776 19.3959 6.35432 19.2292C6.77089 19.0626 10.4789 16.1459 10.4789 16.1459C10.4789 16.1459 12.4793 14.4792 13.4064 14.1875C14.3334 13.8958 15.0209 12.8125 16.0001 12.1875C16.7262 11.7241 18.1496 10.7118 18.8376 10.2188H16.4314C12.4851 11.6093 9.32514 13.6704 8.31264 14.0208C7.22957 14.3957 0.502762 17.6026 0.499512 17.6041Z"
        fill="#DB1920"
      />
      <path
        d="M0.499512 12.8125L0.500137 16C0.500137 16 6.81264 13.375 8.00014 12.9709C9.18764 12.5667 10.8126 11.6562 11.1876 11.5C11.4558 11.3882 13.3852 10.6375 14.4633 10.2188H10.4415C7.24839 10.9898 0.502762 12.8116 0.499512 12.8125Z"
        fill="#DB1920"
      />
      <path
        d="M0.500137 11.5312C1.75301 11.1458 4.52745 10.5956 6.5592 10.2188H0.499512L0.500137 11.5312Z"
        fill="#DB1920"
      />
      <path
        d="M18.5421 28.2375C18.8026 26.1071 20.0796 20.9791 20.828 19.3125C21.7005 17.3701 22.1826 15.7911 22.6738 14.4994C23.3471 12.7291 23.5474 11.5807 23.998 10.2188H22.7407C21.7291 12.2274 19.7686 13.5612 19.3749 14.4375C18.9629 15.3542 16.1874 18.2031 15.6874 19.25C15.2499 20.1656 12.9567 23.0696 12.6654 23.5312C11.2279 25.8081 9.87744 27.8259 9.43738 28.6042C8.37144 30.4892 7.77344 31.5047 7.77344 31.5047H17.5624C17.5624 31.5047 17.8772 30.1501 18.3085 29.1094C18.4255 28.8307 18.5041 28.5374 18.5421 28.2375Z"
        fill="#DB1920"
      />
      <path
        d="M31.2085 9.12976C30.6661 8.88251 30.0348 8.65576 28.1876 7.60438C26.8333 6.83313 24.8951 7.34438 24.177 7.82313C23.592 8.21251 21.7295 8.72938 20.1045 8.64563C19.3439 8.60688 18.1458 8.04876 17.2708 8.00001C16.3958 7.95126 14.1583 8.82813 13.6176 8.79938C12.5557 8.73528 11.5036 8.55887 10.4789 8.27313C8.96201 7.83501 6.28076 6.72938 4.00014 7.52751C2.90129 7.92093 1.82565 8.37637 0.778387 8.89163C0.694638 8.93285 0.624117 8.99671 0.574824 9.07597C0.525532 9.15524 0.499441 9.24673 0.499512 9.34007V9.65626H31.5001V9.58438C31.5002 9.48861 31.4728 9.39483 31.4211 9.31422C31.3694 9.23362 31.2955 9.16958 31.2085 9.12976Z"
        fill="#DB1920"
      />
      <path
        d="M31.4992 10.2188H29.5347C30.2725 11.0093 30.9909 12.2479 31.5002 12.7571L31.4992 10.2188Z"
        fill="#DB1920"
      />
      <path
        d="M27.5625 19.8125C27.2438 18.3479 27.1062 16.2899 26.5312 13.9062C26.4198 13.4444 26.1875 11.0461 26.1096 10.2188H24.8461C24.3042 12.2295 23.9336 13.5861 23.7188 14.4688C23.1255 16.9076 21.0975 22.1068 20.8281 26.1642C20.6524 28.8116 20.0625 31.5047 20.0625 31.5047H29.5625C29.2538 30.1763 28.625 28.3125 28.5321 25.8206C28.4102 22.5521 27.8863 21.2991 27.5625 19.8125Z"
        fill="#DB1920"
      />
      <path
        d="M28.3769 10.2188H26.9502C27.1554 11.2891 27.8874 15.0972 28.0838 16.0042C28.3129 17.0625 29.0838 20.8042 29.3754 21.8958C29.6671 22.9874 30.1669 25.5625 30.4585 26.3542C30.7501 27.1459 31.5002 29.4271 31.5002 29.4271V15.2879C31.1997 14.9325 30.922 14.5584 30.6689 14.1679C29.4643 12.2776 29.4403 11.5592 28.3769 10.2188Z"
        fill="#DB1920"
      />
    </svg>
  );
}

export default LandIcon;
